import React, { useState, useCallback, useMemo } from 'react';
import { Dropdown, Menu, Content, MenuItem } from '@root/components/Dropdown';
import './style.less';
import Icon from '../Icon';
import { IHouse } from '@root/types/house';

interface IProps {
  onSelect: (v: string) => void;
  houseList: IHouse[];
  currentHouseId: string;
}

const HouseSelector = ({ onSelect, houseList, currentHouseId }: IProps) => {
  const [visible, setVisible] = useState(false);

  const onSelectHouse = useCallback(
    (v: string) => {
      setVisible(false);
      onSelect(v);
    },
    [onSelect],
  );

  const handleOpen = useCallback((value: boolean) => {
    setVisible(value);
  }, []);

  const _name = useMemo(() => {
    if (currentHouseId && houseList?.length) {
      const { name } = houseList.find((i) => i.id === currentHouseId) || {};
      return name || '';
    }
    return '';
  }, [currentHouseId, houseList]);

  return (
    <Dropdown
      visible={visible}
      align="left"
      // origin="50%"
      onOpen={handleOpen}
      className="house-dropdown"
    >
      <Menu>
        <div className="house-icon">
          <Icon type="home" />
        </div>

        <p className="house-name">{_name}</p>
        {/* {showName && name && (
          <Typography
            color="background.text"
            nowrap
            className="houseDropdown-label"
          >
            {name}
          </Typography>
        )}
        {showName && !name && <StyleSkeletonName />} */}
      </Menu>
      <Content>
        {houseList.map((house) => (
          <MenuItem
            key={house.id}
            // justify="center"
            // align="center"
            onClick={() => onSelectHouse(house.id)}
          >
            <div className="name-item">
              <p className="name-text">{house.name}</p>
              {house.id === currentHouseId && <Icon type="selected" />}
            </div>
          </MenuItem>
        ))}
      </Content>
    </Dropdown>
  );
};

export default HouseSelector;
